import { findSoftRow, isSoftRow } from './arb.js'

// the yield of a leg is published on the sharp row, but the bet itself is placed at the soft book,
// so the price that gets highlighted is Bovada's, not the sharp one it is measured against
const FIELD_TO_YIELD = {
  homePrice: 'homeYield',
  drawPrice: 'drawYield',
  awayPrice: 'awayYield',
  spreadPoints: 'spreadYield',
  homeSpreadPrice: 'homeSpreadYield',
  awaySpreadPrice: 'awaySpreadYield',
  underPrice: 'underYield',
  overPrice: 'overYield'
}

export const findValueBets = (event, minYield) => {
  const soft = findSoftRow(event && event.bookieList)
  if (!soft) {
    return []
  }

  const best = new Map()

  for (const row of (event && event.bookieList) || []) {
    if (isSoftRow(row)) {
      continue
    }
    for (const [field, yieldField] of Object.entries(FIELD_TO_YIELD)) {
      const value = row[yieldField]
      if (typeof value !== 'number' || value <= 0 || value < minYield) {
        continue
      }
      // the yield is published on the sharp row even when the soft book has no price on that leg, and
      // highlighting a cell that renders an em dash is worse than not highlighting at all
      if (!(soft[field] > 1)) {
        continue
      }
      // the same soft price can beat several sharps, it is still one bet, so keep the strongest
      const current = best.get(field)
      if (!current || value > current.yield) {
        best.set(field, { yield: value, field, against: row.bookmaker, cells: [{ bookmaker: soft.bookmaker, field }] })
      }
    }
  }

  return [...best.values()].sort((a, b) => b.yield - a.yield)
}

export const buildValueCellIndex = (event, minYield) => {
  const index = new Map()
  findValueBets(event, minYield).forEach((bet, betIndex) => {
    bet.cells.forEach((cell) => {
      const key = `${cell.bookmaker}|${cell.field}`
      // the strongest value bet wins the cell when several land on the same price
      if (!index.has(key)) {
        index.set(key, { betIndex, yield: bet.yield })
      }
    })
  })
  return index
}
